module.exports = __webpack_public_path__ + "06f68a3510fdc79d7ab005a029ee98e8.png";